import httpService from "services/api.service";

export const getCity = async (params) => {
  try {
    const res = await httpService.get("/cities", { params });

    return res;
  } catch (error) {
    throw error.response.data.msg;
  }
};
